import {Component, OnDestroy} from '@angular/core';
import {DispatcherService} from 'front-base-angular-core/angular/projects/front-base-angular-core/src/public-api';

interface FsDocument extends HTMLDocument {
  fullscreenElement: Element;
  mozFullScreenElement?: Element;
  webkitFullscreenElement?: Element;
  msFullscreenElement?: Element;
  msExitFullscreen?: () => void;
  mozCancelFullScreen?: () => void;
  webkitExitFullscreen?: () => void;
}

export function isFullScreen(): boolean {
  const fsDoc = <FsDocument>document;
  return !!(fsDoc.fullscreenElement || fsDoc.mozFullScreenElement || fsDoc.webkitFullscreenElement || fsDoc.msFullscreenElement);
}

interface FsDocumentElement extends HTMLElement {
  msRequestFullscreen?: () => void;
  mozRequestFullScreen?: () => void;
  webkitRequestFullscreen?: () => void;
}

export function toggleFullScreen(): void {
  const fsDoc = <FsDocument>document;

  if (!isFullScreen()) {
    const fsDocElem = <FsDocumentElement>document.documentElement;

    if (fsDocElem.requestFullscreen) {
      fsDocElem.requestFullscreen();
    } else if (fsDocElem.msRequestFullscreen) {
      fsDocElem.msRequestFullscreen();
    } else if (fsDocElem.mozRequestFullScreen) {
      fsDocElem.mozRequestFullScreen();
    } else if (fsDocElem.webkitRequestFullscreen) {
      fsDocElem.webkitRequestFullscreen();
    }
  } else if (fsDoc.exitFullscreen) {
    fsDoc.exitFullscreen();
  } else if (fsDoc.msExitFullscreen) {
    fsDoc.msExitFullscreen();
  } else if (fsDoc.mozCancelFullScreen) {
    fsDoc.mozCancelFullScreen();
  } else if (fsDoc.webkitExitFullscreen) {
    fsDoc.webkitExitFullscreen();
  }
}

@Component({
  selector: 'si-bottom-bar',
  templateUrl: './bottom-bar.component.html',
  styleUrls: ['./bottom-bar.component.scss']
})
export class BottomBarComponent implements OnDestroy {
  fullScreenIcon = false;
  enableButton = false;
  formName = '';
  showSubmitButton = false;
  showSignButton = false;
  submitButtonText: string;
  hideSubmitIcon = false;

  constructor(private dispatcher: DispatcherService) {
    this.registerEvents();
  }

  back() {
    window.history.go(-1);
  }

  forward() {
    window.history.go(+1);
  }

  reload() {
    window.location.reload();
  }

  toggleFullScreen() {
    this.fullScreenIcon = !this.fullScreenIcon;
    toggleFullScreen();
  }

  submit() {
    this.dispatcher.exec('bottom-bar-submit');
  }

  sign() {
    this.dispatcher.exec('bottom-bar-sign');
  }

  registerEvents() {
    this.dispatcher.register('bottom-bar-show-submit-button', (showButton, formName, buttonText, hideIcon) => {
      setTimeout(() => {
        this.showSubmitButton = showButton;
        if (showButton) {
          this.submitButtonText = buttonText || 'SI_SAVE';
          this.hideSubmitIcon = hideIcon;
          this.formName = formName;
        }
      });
    });

    this.dispatcher.register('bottom-bar-show-sign-button', (showButton, formName) => {
      setTimeout(() => {
        this.showSignButton = showButton;
        this.formName = formName;
      });
    });

    this.dispatcher.register('bottom-bar-enable-button', (enableButton) => {
      setTimeout(() => {
        this.enableButton = enableButton;
      });
    });

    this.dispatcher.register('bottom-bar-hide-buttons', () => {
      setTimeout(() => {
        this.showSubmitButton = false;
        this.showSignButton = false;
      });
    });
  }

  ngOnDestroy() {
    this.dispatcher.unregister('bottom-bar-show-submit-button');
    this.dispatcher.unregister('bottom-bar-show-sign-button');
    this.dispatcher.unregister('bottom-bar-enable-button');
  }
}
